import { useAnalytics } from "../../context/AnalyticsContext";
import "./DashboardGlobal.scss";
import { isNewAnalyticsEnabled } from "../../services/AnalyticsReadAPI";

const Statistics = () => {

  const { statistics } = useAnalytics();


  const formatSeconds = seconds => `${Math.floor(seconds / 60)}:${(seconds % 60).toString().padStart(2, '0')}`;

  return (
    <div className="stats-row">
      <div className="stat-card">
        <div className="stat-label">TIME SPENT</div>
        <div className="stat-value">{isNewAnalyticsEnabled ? (statistics.averageTime == null ? "—" : formatSeconds(Math.round(statistics.averageTime))) : formatSeconds(statistics.averageTime)}</div>
        <div className="stat-sub">Average</div>
      </div>
  
      <div className="stat-card">
        <div className="stat-label">SESSIONS</div>
        <div className="stat-value">{Math.ceil(statistics.totalSessionCount)}</div>
        <div className="stat-sub">Total</div>
      </div>
  
      <div className="stat-card">
        <div className="stat-label">SCORE</div>
        <div className="stat-value">{isNewAnalyticsEnabled && statistics.averageScore == null ? "—" : `${Math.round(statistics.averageScore)}%`}</div>
        <div className="stat-sub">Average</div>
      </div>
    </div>
  );
}

export default Statistics;
